import React, { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import "./Dimmer.css";
import LinearSlider from "./Sliders/LinearSlider";
import {
  DeleteEquipmentButton,
  DeleteEquipments,
  UpdateEquipmentButton,
  UpdateEquipments,
} from "../../api/api";
import { Link, useNavigate, useParams } from "react-router-dom";
import SuccessToast from "../toasts/SuccessToast";
import { MqttContext } from "../../context/MQTTContext";
import WarningAlert from "../sweeAlerts/WarningAlert";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const Dimmer = ({ equipment_id }) => {
  const {
    authUser,
    setIsLoading,
    equipmentButtons,
    devices,
    setEquipmentButtons,
    equipments,
    setEquipments,
    handleEquipmentsListModal,
    setSelectedEquipment,
    handleChangeNameModal,
    setChangeNameOptions,
    setChartInfo,
    handleChartModal,
    update,
    selectedButtons,
    selectedEquipment,
    refreshMqtt,
    currentRoom,
  } = useContext(Context);
  const { clients } = useContext(MqttContext);

  const [buttons, setButtons] = useState([]);
  const [buttonStates, setButtonStates] = useState({});
  const [editButton, setEditButton] = useState(null);
  const [editedButtonName, setEditedButtonName] = useState("");
  const [changedButton, setChangedButton] = useState(false);
  const [changeButton, setChangeButton] = useState(null);
  const [newSliderValues, setNewSliderValues] = useState({});
  const [ColoredButton, setColoredButton] = useState(null);
  const [editEquipmentName, setEditEquipmentName] = useState(false);
  const [editedEquipmentName, setEditedEquipmentName] = useState("");

  const navigate = useNavigate();

  const { equipment_id: eq_id, room_id, equipment_type: eq_type } = useParams();

  const buttonStatesRef = useRef(buttonStates);

  useEffect(() => {
    buttonStatesRef.current = buttonStates;
  }, [buttonStates]);

  useEffect(() => {
    let btns = equipmentButtons
      .filter((eq_btn) => eq_btn.equipment_id == eq_id)
      .map((btn) => ({
        ...btn,
        digit: Number(btn.digit),
      }));

    setButtons(btns);
    setSelectedEquipment({
      id: eq_id,
      type: eq_type,
    });
    if (btns.length) {
      let clientsId = [];
      let messageListener;
      btns.forEach((button) => {
        let device = devices.find((d) => d.id == button.device_id);
        if (!device) {
          return;
        }
        if (
          device.is_bus == 1 &&
          clients[device?.bridge_device?.id] &&
          !clientsId.includes(device.id)
        ) {
          messageListener = (topic, message) => {
            const endOfTwoCharToken =
              String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
            const deviceSerial =
              String.fromCharCode(message[3]) +
              String.fromCharCode(message[4]) +
              String.fromCharCode(message[5]) +
              String.fromCharCode(message[6]) +
              String.fromCharCode(message[7]) +
              String.fromCharCode(message[8]);
            if (
              device.bridge_device.internet_token.slice(-2) ===
                endOfTwoCharToken &&
              device.serial === deviceSerial &&
              (message[10] == 1 || message[10] == 3) &&
              message[2] == 14
            ) {
              setButtonStates((prev) => ({
                ...prev,
                [device.id]: {
                  ...prev[device.id],
                  0: message[11],
                  1: message[12],
                  2: message[13],
                  3: message[14],
                  4: message[15],
                  5: message[16],
                },
              }));
              setColoredButton(null);
            }
          };

          // clients[device.bridge_device.id].removeAllListeners("message");
          clients[device.bridge_device.id].on("message", messageListener);

          let buffer = new ArrayBuffer(10);
          let asciiCode = new Uint8Array(buffer);
          asciiCode[0] = 14;
          asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
          asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
          asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
          asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
          asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
          asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
          asciiCode[7] = device.type + 50;
          asciiCode[8] = 3;
          asciiCode[9] = 0;

          let message = device.bridge_device.internet_token;

          // ترکیب رشته و بافر
          let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

          clients[device.bridge_device.id].publish(
            device.bridge_device.serial + "/sys",
            combinedMessage,
          );
          clientsId = [...clientsId, device.id];
        } else if (
          device.id &&
          device.username &&
          device.password &&
          clients[device.id] &&
          !clientsId.includes(device.id)
        ) {
          messageListener = (topic, message) => {
            const endOfTwoCharToken =
              String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
            if (
              device.internet_token.slice(-2) === endOfTwoCharToken &&
              (message[2] == 1 || message[2] == 3)
            ) {
              setButtonStates((prev) => ({
                ...prev,
                [device.id]: {
                  ...prev[device.id],
                  0: message[3],
                  1: message[4],
                  2: message[5],
                  3: message[6],
                  4: message[7],
                  5: message[8],
                },
              }));
              setColoredButton(null);
            }
          };

          // clients[device.id].removeAllListeners("message");
          clients[device.id].on("message", messageListener);
          const decimalArray = [3, 0];
          const asciiArray = decimalArray.map((num) =>
            String.fromCharCode(num),
          );

          clients[device.id].publish(
            device.serial + "/sys",
            device.internet_token + asciiArray.join(""),
          );
          clientsId = [...clientsId, device.id];
        }
      });

      return () => {
        btns.forEach((button) => {
          let device = devices.find((d) => d.id == button.device_id);
          if (!device) {
            return;
          }
          if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
            clients[device.bridge_device.id].removeAllListeners("message");
          } else if (
            device.id &&
            device.username &&
            device.password &&
            clients[device.id]
          ) {
            clients[device.id].removeAllListeners("message");
          }
        });
      };
    }
  }, [update, equipmentButtons, refreshMqtt, eq_id]);

  useEffect(() => {
    let changedDigitVal = buttonStates[changeButton?.device_id];
    let client;
    if (
      changeButton &&
      newSliderValues.buttonId == changeButton.id &&
      newSliderValues.digit == changeButton.digit &&
      Math.floor((newSliderValues.value * 255) / 100) != changedDigitVal
    ) {
      let device = devices.find((d) => d.id == changeButton.device_id);
      if (!device) {
        return;
      }
      if (device.is_bus == 1) {
        let buffer = new ArrayBuffer(20);
        let asciiCode = new Uint8Array(buffer);
        let baseCode = ["0", "0", "0", "0", "0", "0", "0", "0"];
        baseCode[changeButton.digit] = "1";
        asciiCode[0] = 14;
        asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
        asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
        asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
        asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
        asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
        asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
        asciiCode[7] = device.type + 50;
        asciiCode[8] = 1;
        asciiCode[9] = parseInt(baseCode.reverse().join(""), 2);
        asciiCode[10] =
          newSliderValues.digit == 0
            ? Math.floor(newSliderValues.value)
            : buttonStates[device.id][changeButton.digit];
        asciiCode[11] =
          newSliderValues.digit == 1
            ? Math.floor(newSliderValues.value)
            : buttonStates[device.id][changeButton.digit];
        asciiCode[12] =
          newSliderValues.digit == 2
            ? Math.floor(newSliderValues.value)
            : buttonStates[device.id][changeButton.digit];
        asciiCode[13] =
          newSliderValues.digit == 3
            ? Math.floor(newSliderValues.value)
            : buttonStates[device.id][changeButton.digit];
        asciiCode[14] =
          newSliderValues.digit == 4
            ? Math.floor(newSliderValues.value)
            : buttonStates[device.id][changeButton.digit];
        asciiCode[15] =
          newSliderValues.digit == 5
            ? Math.floor(newSliderValues.value)
            : buttonStates[device.id][changeButton.digit];
        asciiCode[16] = 101;
        asciiCode[17] = 101;
        asciiCode[18] =
          newSliderValues.digit == 0 ||
          newSliderValues.digit == 1 ||
          newSliderValues.digit == 2
            ? 100
            : 101;
        asciiCode[19] =
          newSliderValues.digit == 3 ||
          newSliderValues.digit == 4 ||
          newSliderValues.digit == 5
            ? 100
            : 101;

        let message = device.bridge_device.internet_token;

        // ترکیب رشته و بافر
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
        clients[device.bridge_device.id].publish(
          device.bridge_device.serial + "/sys",
          combinedMessage,
        );
      } else {
        let buffer = new ArrayBuffer(12);
        let asciiCode = new Uint8Array(buffer);
        let baseCode = ["0", "0", "0", "0", "0", "0", "0", "0"];
        baseCode[changeButton.digit] = "1";
        asciiCode[0] = 1;
        asciiCode[1] = parseInt(baseCode.reverse().join(""), 2);
        asciiCode[2] =
          newSliderValues.digit == 0
            ? Math.floor(newSliderValues.value)
            : buttonStates[device.id][changeButton.digit];
        asciiCode[3] =
          newSliderValues.digit == 1
            ? Math.floor(newSliderValues.value)
            : buttonStates[device.id][changeButton.digit];
        asciiCode[4] =
          newSliderValues.digit == 2
            ? Math.floor(newSliderValues.value)
            : buttonStates[device.id][changeButton.digit];
        asciiCode[5] =
          newSliderValues.digit == 3
            ? Math.floor(newSliderValues.value)
            : buttonStates[device.id][changeButton.digit];
        asciiCode[6] =
          newSliderValues.digit == 4
            ? Math.floor(newSliderValues.value)
            : buttonStates[device.id][changeButton.digit];
        asciiCode[7] =
          newSliderValues.digit == 5
            ? Math.floor(newSliderValues.value)
            : buttonStates[device.id][changeButton.digit];
        asciiCode[8] = 101;
        asciiCode[9] = 101;
        asciiCode[10] =
          newSliderValues.digit == 0 ||
          newSliderValues.digit == 1 ||
          newSliderValues.digit == 2
            ? 100
            : 101;
        asciiCode[11] =
          newSliderValues.digit == 3 ||
          newSliderValues.digit == 4 ||
          newSliderValues.digit == 5
            ? 100
            : 101;

        let message = device.internet_token;

        // ترکیب رشته و بافر
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
        clients[device.id].publish(device.serial + "/sys", combinedMessage);
      }
    }
  }, [changedButton]);

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str); // تبدیل رشته به بایت‌ها

    // ساخت یک بافر جدید که به اندازه رشته و بافر اصلی است
    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);

    // قرار دادن رشته در ابتدا
    newBuffer.set(encodedString, 0);

    // قرار دادن بافر در ادامه
    newBuffer.set(new Uint8Array(buffer), encodedString.length);

    return newBuffer;
  };

  const handleChangeStateButton = (button) => {
    let device = devices.find((d) => d.id == button.device_id);
    if (!device) {
      return;
    }
    if (Object.keys(buttonStates[device.id] ?? {}).length) {
      let prevVal = buttonStates[device.id][button.digit];

      setNewSliderValues({
        buttonId: button.id,
        digit: button.digit,
        value: prevVal ? 0 : 255,
      });
      setChangeButton(button);
      setColoredButton(button.id);
      setChangedButton((prev) => !prev);
    }
  };

  const handleChangeSlider = (value, button) => {
    let device = devices.find((d) => d.id == button.device_id);
    if (!device) {
      return;
    }
    if (Object.keys(buttonStatesRef.current[device.id] ?? {}).length) {
      setNewSliderValues({
        buttonId: button.id,
        digit: button.digit,
        value: (value[0] * 255) / 100,
      });
      setChangeButton(button);
      setColoredButton(button.id);
      setChangedButton((prev) => !prev);
    }
  };

  const handleRemoveButton = (e, button) => {
    setIsLoading(true);
    e.preventDefault();
    DeleteEquipmentButton({
      equipment_button_id: button.id,
    }).then((res) => {
      if (res.status == 200) {
        setEquipmentButtons(equipmentButtons.filter((b) => b.id != button.id));
        SuccessToast("با موفقیت حذف گردید");
        setIsLoading(false);
      }
    });
  };

  const handleChangeNameButton = (button) => {
    const onSubmitFunc = ({ button, name }) => {
      UpdateEquipmentButton({
        equipment_button_id: button.id,
        name: name,
        digit: button.digit,
        icon: button.icon,
      }).then((res) => {
        if (res.status == 200) {
          setEditedButtonName("");
          setEditButton(null);
          SuccessToast("با موفقیت ثبت شد");

          const index = equipmentButtons.findIndex(
            (item) => item.id === button.id,
          );

          if (index !== -1) {
            const updatedButtons = [...equipmentButtons];
            updatedButtons[index] = {
              ...updatedButtons[index],
              name: name,
            };

            setEquipmentButtons(updatedButtons);
          }
        }
      });
    };
    const newOptions = {
      name: button.name,
      onSubmit: (newName) => {
        onSubmitFunc({ button, name: newName });
      },
    };
    setChangeNameOptions(newOptions);
    handleChangeNameModal();
  };

  // const getButtonDataScenarioMode = (digit) => {
  //   // Get button Info
  //   AllEquipmentButton({
  //     equipment_id,
  //     digit,
  //   }).then(({ data }) => {
  //     if (data.equipment_buttons.length) {
  //       if (scenarioCommandDetail.id) {
  //         UpdateScenarioCommand({
  //           scenario_command_id: scenarioCommandDetail.id,
  //           device_id: data.equipment_buttons[0].device_id,
  //           time: scenarioCommandDetail.time,
  //           data: data.equipment_buttons[0].data,
  //           command_name: data.equipment_buttons[0].digit,
  //           icon: data.equipment_buttons[0].icon ?? selectedIcon,
  //         }).then(({ data }) => {});
  //       } else {
  //         CreateScenarioCommand({
  //           scenario_id: addScenarioCommandDetail.scenario_id,
  //           data: data.equipment_buttons[0].data,
  //           icon: data.equipment_buttons[0].icon ?? selectedIcon,
  //           command_name: data.equipment_buttons[0].digit,
  //           device_id: data.equipment_buttons[0].device_id,
  //           time: 500,
  //         }).then(({ data }) => {});
  //       }
  //     } else {
  //       ErrorToast("کلید تعریف نشده است");
  //     }
  //   });
  // };

  const handleChangeEquipmentName = (equipment_id) => {
    const onSubmitFunc = ({ equipment_id, name }) => {
      UpdateEquipments({
        equipment_id,
        name,
      }).then((res) => {
        const updatedEquipments = equipments.map((item) =>
          item.id === equipment_id
            ? {
                ...item,
                equipment: { ...item.equipment, name: name },
              }
            : item,
        );
        setEquipments(updatedEquipments);
      });
    };
    const newOptions = {
      name:
        equipments.find((eq) => eq.id == equipment_id)?.equipment.name ?? "",
      onSubmit: (newName) => {
        onSubmitFunc({ equipment_id, name: newName });
      },
    };
    setChangeNameOptions(newOptions);
    handleChangeNameModal();
  };

  const handleRemoveEquipment = (equipment_id) => {
    WarningAlert(
      "آیا از حذف این تجهیز اطمینان دارید؟",
      "",
      "تایید",
      "انصراف",
    ).then(function (result) {
      if (result.value) {
        DeleteEquipments({ equipment_id }).then((res) => {
          SuccessToast(res.data.message);
          let newEquipments = equipments.filter((eq) => eq.id != equipment_id);
          setEquipments(newEquipments);
          let lstEquipment = newEquipments.find(
            (eq) => eq.room_id == currentRoom,
          );
          handleEquipment(lstEquipment, currentRoom);
        });
      }
    });
  };

  const handleEquipment = (equipment, roomId) => {
    if (!equipment) return navigate("/room/" + roomId);
    equipment = equipment.equipment;
    setSelectedEquipment({
      id: equipment.id,
      type: equipment.type,
    });
    if (!equipment) {
      return navigate("/");
    } else if (equipment.type == 1) {
      return navigate(
        "/room/key/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 3) {
      return navigate(
        "/room/remote/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 4) {
      return navigate(
        "/room/dimmer/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 5) {
      return navigate(
        "/room/thermostat/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 9) {
      return navigate(
        "/room/rgb/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 99) {
      return navigate(
        "/room/wireless-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 100) {
      return navigate(
        "/room/television/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 501) {
      return navigate(
        "/room/fan-coil/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 401) {
      return navigate(
        "/room/scenario-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 503) {
      return navigate(
        "/room/humidity/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 502) {
      return navigate(
        "/room/motor/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9998) {
      return navigate(
        "/room/input/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9999) {
      return navigate(
        "/room/input-status/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 600) {
      return navigate(
        "/room/data-logger/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    }
  };

  const renderButtons = () => {
    return buttons.map((button, index) => {
      let device = devices.find((d) => d.id == button.device_id);
      if (!device) {
        return;
      }
      return (
        <div
          className="dimmer mb-3 bg-white pt-2"
          key={index}
          style={{
            boxShadow:
              buttonStates?.[device.id]?.[button.digit] !== undefined &&
              ColoredButton != button.id
                ? "0 0.25rem 1rem rgba(147, 158, 170, 0.45)"
                : "0 0.25rem 1rem rgba(0, 122, 255, 0.45)",
          }}
        >
          <div className="row mx-0">
            <div className="col-12 col-md-1">
              {authUser.is_admin ? (
                <div
                  className="btn-group d-inline-block"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-icon rounded-pill dropdown-toggle hide-arrow"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bx bx-dots-vertical-rounded"></i>
                  </button>
                  <ul className="dropdown-menu ">
                    {device.is_bus == 0 &&
                    ((device.fw_version >= 12 && device.fw_version <= 14) ||
                      device.fw_version >= 17) ? (
                      <li
                        onClick={(e) => {
                          setChartInfo({
                            type: 1,
                            device_id: button.device_id,
                            chart_num: 1,
                            first_index: button.digit + 1,
                            count: 1,
                            coefficients: [],
                            names: { [button.digit]: button.name },
                          });
                          handleChartModal();
                        }}
                      >
                        <a className="dropdown-item">نمایش نمودار</a>
                      </li>
                    ) : null}

                    <li
                      onClick={() => {
                        handleChangeNameButton(button);
                      }}
                    >
                      <a className="dropdown-item">تغییر نام</a>
                    </li>
                    <li onClick={(e) => handleRemoveButton(e, button)}>
                      <a className="dropdown-item">حذف</a>
                    </li>
                  </ul>
                </div>
              ) : null}
            </div>
            <div className="col-12 col-md-11">
              <div className="row">
                <div
                  className="col-10 col-md-9 align-middle"
                  style={{ padding: "0 1.7rem" }}
                >
                  <LinearSlider
                    value={
                      buttonStates?.[device.id]?.[button.digit] !== undefined
                        ? Math.floor(
                            (buttonStates[device.id][button.digit] * 100) / 255,
                          )
                        : 0
                    }
                    setValue={(value) => {
                      handleChangeSlider(value, button);
                    }}
                  />
                </div>
                <div className="col-2 col-md-3 text-center my-auto">
                  <div className="text-center">
                    <p
                      className={
                        editButton == button.id
                          ? "d-none"
                          : "text-center p-0 m-0 d-block"
                      }
                    >
                      {button.name}
                    </p>
                    <div
                      className={
                        editButton == button.id ? "mt-2 d-block" : "d-none"
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                    >
                      <div>
                        <input
                          id="smallInput"
                          className="form-control form-control-sm text-center"
                          name="room_name"
                          type="text"
                          placeholder="نام کلید را وارد کنید"
                          value={editedButtonName}
                          onChange={(e) => setEditedButtonName(e.target.value)}
                        />
                      </div>
                      <div className="mt-1">
                        <button
                          type="button"
                          className="btn btn-xs btn-success-app submit-add-room me-2"
                          onClick={() => handleChangeNameButton(button)}
                        >
                          ثبت
                        </button>
                        <button
                          type="button"
                          className="btn btn-xs btn-success-app mt-1"
                          onClick={(e) => setEditButton(null)}
                        >
                          انصراف
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between px-2">
                <div>
                  <div className="form-check form-switch mb-2 p-0">
                    <label className="switch switch-success-app">
                      <input
                        type="checkbox"
                        className="switch-input"
                        onChange={() => handleChangeStateButton(button)}
                        checked={
                          buttonStates?.[device.id]?.[button.digit]
                            ? "checked"
                            : ""
                        }
                      />
                      <span
                        className="switch-toggle-slider"
                        style={{ transform: "rotate(180deg)" }}
                      >
                        <span className="switch-off"></span>
                        <span className="switch-on"></span>
                      </span>
                    </label>
                  </div>
                </div>
                <div>
                  <span style={{ fontSize: "11px" }}>
                    {"C" + (button.digit + 1)}-S/
                    {device.serial}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div
      className="card h-100"
      style={{ backgroundColor: "#fff0", boxShadow: "none" }}
    >
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom mb-3 p-0 pt-2"
        style={{ zIndex: "1" }}
      >
        <h5 className={editEquipmentName ? "d-none" : ""}>
          {equipments.find((eq) => eq.id == eq_id)?.equipment?.name ?? ""}
        </h5>
        <div
          className={editEquipmentName ? "mt-2 d-block" : "d-none"}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <div>
            <input
              id="smallInput"
              className="form-control form-control-sm text-center"
              name="room_name"
              type="text"
              placeholder="نام تجهیز را وارد کنید"
              value={editedEquipmentName}
              onChange={(e) => setEditedEquipmentName(e.target.value)}
            />
          </div>
          <div className="mt-1">
            <button
              type="button"
              className="btn btn-xs btn-success-app submit-add-room me-2"
              onClick={() => handleChangeEquipmentName()}
            >
              ثبت
            </button>
            <button
              type="button"
              className="btn btn-xs btn-success-app"
              onClick={(e) => setEditEquipmentName(false)}
            >
              انصراف
            </button>
          </div>
        </div>
        <div>
          {authUser.is_admin ? (
            <>
              <button
                type="button"
                className="btn btn-success-app btn-icon me-2"
                style={{ borderColor: "rgb(0, 165, 148)" }}
                onClick={() => handleRemoveEquipment(selectedEquipment.id)}
              >
                <i className="bx bx-trash"></i>
              </button>
              <div className="btn-group">
                <button
                  type="button"
                  className="btn btn-success-app btn-icon dropdown-toggle hide-arrow"
                  style={{ borderColor: "rgb(0, 165, 148)" }}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bx bx-dots-vertical-rounded"></i>
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <Link
                      className="dropdown-item"
                      onClick={(e) => {
                        e.preventDefault();
                        handleEquipmentsListModal(true);
                      }}
                    >
                      افزدون تجهیز
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to={
                        "/room/select-device/" +
                        room_id +
                        "/" +
                        eq_id +
                        "/" +
                        eq_type
                      }
                    >
                      افزدون کانال به تجهیز
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      onClick={(e) => {
                        e.preventDefault();
                        handleChangeEquipmentName(
                          equipments.find((eq) => eq.id == eq_id)?.id,
                        );
                      }}
                    >
                      تغییر نام تجهیز
                    </Link>
                  </li>
                </ul>
              </div>
            </>
          ) : null}

          {/* <BackButton url={"/room/" + room_id} /> */}
        </div>
      </div>
      <div
        className="card-body scrollbar mt-sm-2"
        style={{ paddingBottom: "10rem" }}
      >
        {/* <SimpleBar style={{ maxHeight: "100%", padding: "1.5rem" }}> */}
        {renderButtons()}
        {/* </SimpleBar> */}
      </div>
    </div>
  );
};

export default React.memo(Dimmer);
